export default __webpack_public_path__ + "static/media/tapeTwo.7aca26b6.svg";